export type FloatingFooterProps = {
  children?: React.ReactNode
}

export const FormFloatingFooter = ({ children }: FloatingFooterProps) => {
  return <section className="floating-footer">{children}</section>
}
